import { render, staticRenderFns } from "./CommonFacialDeviceDetailForm.vue?vue&type=template&id=c92c63b0&scoped=true&"
import script from "./CommonFacialDeviceDetailForm.vue?vue&type=script&lang=js&"
export * from "./CommonFacialDeviceDetailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c92c63b0",
  null
  
)

export default component.exports